import React from 'react';
import './style.scss';

const LastActiveBanner = ({ lastActiveAt, spotPublishedAt, desktop }) => {
    const today = new Date();
    const diffInDays = Math.floor((today - new Date(lastActiveAt || spotPublishedAt)) / (1000 * 60 * 60 * 24));

    if (diffInDays > 30) {
        return '';
    }

    let textDate = '';

    if (diffInDays <= 1) {
        textDate = 'today';
    } else if (diffInDays <= 7) {
        textDate = 'this week';
    } else {
        textDate = 'this month';
    }

    return (
        <div className={`spot-dtl-sub-last-active ${desktop ? 'd-md-none' : ''}`}>
            <span />
            <p>Last active {textDate}</p>
        </div>
    );
};

export default LastActiveBanner;
